import { Component, Input, OnChanges } from '@angular/core';
import { FormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import * as _ from 'lodash';

import { TableComponent } from 'shared/table/table/table.component';
import { fieldsInfo } from './fields-info';
import * as utils from 'utils/utils';


@Component({
  moduleId: module.id,
  selector: 'trade-info-form',
  templateUrl: 'trade-info-form.component.html',
  styleUrls: ['trade-info-form.component.scss'],
})
export class TradeInfoFormComponent extends TableComponent implements OnChanges {

  form: UntypedFormGroup;

  @Input() segmentData: Array<any> = [];

  @Input() declare data: any;

  fieldsInfo: any = fieldsInfo;

  get isInValid(): boolean {
    return this.form.invalid;
  }

  // public:
  constructor(private fb: UntypedFormBuilder) {
    super();
  }

  ngOnChanges(changes: any) {
    this.setFormData();
  }

  createForm() {
    const formControls = this.createFormItem(this.data);
    this.form = this.fb.group(formControls);
  }

  setFormData() {
    if (this.form) {
      this.updateForm();
    } else {
      this.createForm();
    }
  }

  getFieldWidthClass(fieldName: string) {
    // width class for cells
    return `size-${this.getFieldCellSize(fieldName, this.fieldsInfo)}`;
  }

  public fieldValidation(item: any, formGroup: UntypedFormGroup): any {
    let validation = super.fieldValidation(item, formGroup);
    // PIES 6.7 validation row was added for test
    const pies65: any = _.find(validation, {name: 'PIES_6_5'});
    if (pies65) {
      validation = [...validation, {
        key: 'pies67',
        title: 'PIES 6.7',
        valid: pies65.valid,
      }];
    }
    return validation;
  }

  // handlers:
  onSelectChange(selected: any, item: any, name: string) {
    item[name] = selected.id !== 0 ? selected.name : '';
  }

  // private
  private createFormItem(obj: any = {}): any {
    return _.reduce(this.segmentData, (result: any, item: any) => {
      const control = new UntypedFormControl(obj[item.item_name], this.getItemValidators(item.validation));
      result[item.field_map] = control;
      return result;
    }, {});
  }

  private updateForm(): void {
    _.each(this.segmentData, (item: any) => {
      const control = this.form.get(item.field_map);
      if (control) { control.setValue(this.data[item.item_name]); }
    });
  }
}
